import React from 'react'

export default props => (
	<form
		method="post"
		action={`#`}
		className={props.formClass}
		aria-label="Search"
	>
		<div className="input-group">
			<input
				className={props.inputClass}
				placeholder={props.placeholder}
				type="email"
				name="email"
			/>
			<div className="input-group-append">
				<button className={props.buttonClass} type="submit">
					Subscribe
				</button>
			</div>
		</div>
	</form>
)
